<script lang="ts">
    import { Component } from "vue-property-decorator";
    import limitFileModal from "../../home/parts/limitFileModal.vue";

    @Component({})
    export default class appLimitFileModal extends limitFileModal {
        isPC = false;

        get isPCDarkMode() {
            return this.$store.state.isPCDarkMode;
        }

        close() {
            this.$emit("closeModal");
        }

        continueCreate() {
            this.$emit("continueCreate");
        }
    }
</script>
